import React, { useEffect, useState } from "react";
import CommonPaginationSection from "../../components/common/CommonPaginationSection";
import { useMilesPoints } from "../../hooks/useMilesPoints";
import { capitalize } from "lodash";
import moment from "moment/moment";

function PointsLeaderboardLogsSection({ board }) {
  const { getMilesPointsLogs } = useMilesPoints();
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    total: 10,
  });
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState([]);

  const loadData = async () => {
    // window.scrollTo({ top: 0, behavior: "smooth" });
    await getMilesPointsLogs({
      setLoading,
      page: pagination.page,
      limit: pagination.perPage,
      callback: (data) => {
        setPagination({ ...pagination, total: data?.totalData || 10 });
        setLogs(data?.logs || []);
      },
      userId: board?.userId,
    });
  };

  useEffect(() => {
    loadData();
  }, [pagination.page, pagination.perPage]);

  if (loading)
    return (
      <div className="w-full flex flex-col py-4 items-center justify-center">
        <div className="primaryLoader"></div>
      </div>
    );

  if (logs?.length === 0) return <></>;

  return (
    <div className="flex flex-col w-full">
      <div className="w-full flex flex-col gap-2">
        {/* Header */}
        <div className="w-full p-4 flex items-center bg-[#F0F6FC] gap-2">
          <div className="w-32 ">
            <small>DATE</small>
          </div>
          <div className="flex flex-1 ">
            <small>ACTIVITY</small>
          </div>
          <div className="w-24 ">
            <small>TYPE</small>
          </div>
          <div className="w-20 ">
            <small>POINT</small>
          </div>
        </div>
        {logs.map((log, index) => {
          const createdAt = moment(log?.createdAt);
          const time = createdAt.format("hh:mm");
          const meridiem = createdAt.format("A").toLowerCase(); // am / pm
          const date = createdAt.format("DD/MM/YYYY");

          return (
            <div
              className="w-full p-4 flex items-center bg-white gap-2"
              key={index}
            >
              <div className="w-32 flex flex-col">
                <small>
                  {time}
                  <small className="text-primary1">{meridiem}</small>{" "}
                </small>
                <small>{date}</small>
              </div>

              <div className="flex flex-1">
                <small>{log?.activity}</small>
              </div>

              <div className="w-24">
                <LogType value={log?.type} />
              </div>

              <div className="w-20">
                <small>{(log?.point || 0)?.toLocaleString()}</small>
              </div>
            </div>
          );
        })}
      </div>
      <CommonPaginationSection
        page={pagination.page}
        perPage={pagination.perPage}
        total={pagination.total}
        callback={(page, perPage) => {
          setPagination({
            ...pagination,
            page,
            perPage,
          });
        }}
      />
    </div>
  );
}

const LogType = ({ value }) => {
  const PrefixElement = () => {
    if (value === "EARNED") {
      return (
        <div className="w-3 h-3 rounded-full bg-[#0B662C] flex shrink-0"></div>
      );
    } else {
      return (
        <div className="w-3 h-3 rounded-full bg-[#B81F25] flex shrink-0"></div>
      );
    }
  };
  return (
    <div className="flex gap-2 items-center">
      <PrefixElement />
      <span className="text-sm">{capitalize(value)}</span>
    </div>
  );
};

const Status = ({ status }) => {
  const statusStyle = () => {
    switch (status) {
      case "booked":
        return "bg-[#009688]/10 text-[#009688]";
      case "registered":
        return "bg-[#1E61DC]/10 text-[#1E61DC]";
      default:
        return "bg-[#1E61DC]/10 text-[#1E61DC]";
    }
  };
  return (
    <div
      className={`text-sm px-2 py-[6px] w-fit rounded-md font-semibold ${statusStyle()}`}
    >
      {status}
    </div>
  );
};

export default PointsLeaderboardLogsSection;
